const state = {
  message: '',
  type: 'success',
  all: null,
  isShow: false
};

const mutations = {
  SHOW_MSG(state, playload) {
    if (typeof playload === 'string') {
      state.message = playload;
      state.type = 'success';
      state.all = {};
    } else {
      state.message = playload.message;
      state.type = playload.type || 'success';
      state.all = { ...playload };
    }
    state.isShow = true;
  },
  CLOSE(state) {
    state.isShow = false;
  },
  SHOW_ERROR_MSG(state, playload) {
    state.type = 'error';
    if (typeof playload === 'string') {
      state.message = playload;
    } else {
      state.message = playload.message;
      state.all = { ...playload };
    }
    state.isShow = true;
  }
};
const actions = {
  showMsg({ commit }, playload) {
    commit('SHOW_MSG', playload);
  },
  showErrorMsg({ commit }, playload) {
    commit('SHOW_ERROR_MSG', playload);
  }
};

const msg = {
  namespaced: true,
  state,
  mutations,
  actions
};

export default msg;
